import "./Title.css";
import React from "react";

export const Title = (props: { FirstText?: string; SecondText?: string }) => {
  return (
    <div className="title-block">
      <h1 className="first-title">{props.FirstText}</h1>
      <h2 className="second-title">{props.SecondText}</h2>
    </div>
  );
};
